import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { NavLink, useParams } from 'react-router-dom'
import { css } from 'emotion'
import styled from '@emotion/styled'
import iconRead from 'assets/icons/ico-read.svg'
import iconUnread from 'assets/icons/ico-unread.svg'
import InlineSVG from 'svg-inline-react'
import PropTypes from 'prop-types'
import { getFullName } from 'shared/utils/helper'
import { getShortDate} from 'shared/utils/time'
import * as Selectors from 'state/selectors'
import { some } from 'shared/utils/array'

const DialogSecondaryText = styled.span`
  font-size: 10rem;
  opacity: 0.4;
  color: ${props => props.active ? '#FFFFFF' : '#90A1B0'};
  text-align: left;
  max-width: 200px;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  &:hover{
    color: #FFFFFF;
  }
`

const DialogContainer = styled(NavLink)`
  padding: 8px;
  color: #353A52;
  background-color: #FFFFFF;
  border-radius: 8px;
  width: 100%;
  cursor: pointer;

  &:hover{
    background-color: #90A1B0;
    color: #FFFFFF;
    ${DialogSecondaryText}{
      color: #FFFFFF;
    }
  }
`

const DialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const ContactName = styled.span`
  font-weight: 700;
  max-width: 200px;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  text-align: left;
`

const DialogBody = styled.p`
  opacity: 0.8;
  margin-top: 4px;
  padding-left: 12px;
  text-align: left;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
`

const activeItem = css`
  background-color: #1283EE !important;
  color: #FFFFFF !important;
`

const Dialog = ({isNotRead, interaction}) => {
  let isBusyTyping = undefined
  const [active, setActive] = useState(false)

  //router logic
  const routerParams = useParams()

  //redux logic
  const selectedInteraction = useSelector(Selectors.getSelectedInteraction)
  const busyTypingCollection = useSelector(Selectors.getBusyTypingCollection)

  //did mount effect
  useEffect(() => {
    if (interaction?.interactionId === selectedInteraction?.interactionId){
      setActive(true)
    } else {
      setActive(false)
    }
  }, [selectedInteraction])

  
  for(let i = 0; i < busyTypingCollection.length; i++){
    isBusyTyping =  some( interaction.threads,  thread => thread?.threadId === busyTypingCollection[i]?.threadId) ? 'Typing...' : undefined
    if(isBusyTyping) break
  }


  //data preparation
  const date = getShortDate(interaction?.lastActivity?.createdAt) || ''
  const name = getFullName(interaction) || 'Unknown Name'
  const message = isBusyTyping || interaction?.lastActivity?.speech || 'Unknown text'
  const lastAuthor = getFullName(interaction, interaction?.lastActivity?.originator) || 'Unknown author'

  return (
    <DialogContainer
      to={`${process.env.CHAT_PUBLIC_PATH}/${routerParams.filterType}/${routerParams.filterId}/${interaction.interactionId}`}
      activeClassName={activeItem}
    >
      <DialogHeader>
        <ContactName>
          {
            interaction?.isRead
              ? <InlineSVG src={iconRead}/>
              : <InlineSVG src={iconUnread}/>
          }
          {' '}
          {name}
        </ContactName>
        <DialogSecondaryText active={active}>{date}</DialogSecondaryText>
      </DialogHeader>
      <DialogBody><DialogSecondaryText active={active}>{`Replied by ${lastAuthor}`}</DialogSecondaryText></DialogBody>
      <DialogBody>{message}</DialogBody>
    </DialogContainer>
  )
}

Dialog.propTypes = {
  interaction: PropTypes.object.isRequired
}

export default Dialog
